// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function openIcon1_click(event, $w) {
	$w("#description1").show();
	$w("#descriptionBox1").show();
	$w("#openIcon1").hide();
	$w("#closeIcon1").show();
	$w("#title1").hide();
	$w("#price1").show();
}

export function closeIcon1_click(event, $w) {
	$w("#description1").hide();
	$w("#descriptionBox1").hide();
	$w("#openIcon1").show();
	$w("#closeIcon1").hide();
	$w("#title1").show();
	$w("#price1").hide();
}

export function column30_click(event, $w) {

	$w("#text59").show();
}

export function vectorImage4_click(event, $w) {
	
	$w("#box7").show();
	$w("#vectorImage4").hide();
    $w("#vectorImage5").show();
	
}

export function vectorImage5_click(event, $w) {
	$w("#box7").hide();
	$w("#vectorImage4").show();
    $w("#vectorImage5").hide();
	
}

export function showdesc1_click_1(event) {
	$w("#spadesc1").show();
	$w("#spaheaderbox").hide();
	$w("#spadesc1").expand();
	$w("#closeSpaDescription").show();
}

export function closeSpaDescription_click(event) {
	$w("#spadesc1").hide();
	$w("#spaheaderbox").show();
	$w("#spadesc1").collapse();
	$w("#closeSpaDescription").hide();
}